import React, { useEffect, useRef, useState } from "react";
import "../css/Home.css";
import Image from "../imgs/formal_photo.png"; // jpg
import "aos/dist/aos.css";
import Aos from "aos";
import Person from "@material-ui/icons/Person";
import Skills from "@material-ui/icons/Settings";
import LoadingRec from "@material-ui/icons/DataUsage";
import ReactIcon from "../icons/reactIcon.png";
import JavaScriptIcon from "../icons/javascriptIcon.png";
import PHPIcon from "../icons/phpIcon.png";
import JQueryIcon from "../icons/jqueryIcon.png";
import HTMLIcon from "../icons/htmlIcon.png";
import CSSIcon from "../icons/cssIcon.png";
import CSharpIcon from "../icons/csharpIcon.png";
import MongoDBIcon from "../icons/mongoDBIcon.png";
import MysqlIcon from "../icons/mysqlIcon.png";
import RestIcon from "../icons/restAPIIcon.png";
import ReduxIcon from "../icons/reduxIcon.png";
import NodeJSIcon from "../icons/nodejsIcon.png";
import ASPIcon from "../icons/aspIcon.png";
import MssqlIcon from "../icons/mssqlIcon.png";
import SQLiteIcon from "../icons/sqliteIcon.png";
import ExpressJSIcon from "../icons/expressjsIcon.png";
import CodeIgniterIcon from "../icons/codeIgniterIcon.png";
import Axios from "axios";
import { URL_ONE } from "../configs/defaultURL";
import { motion } from "framer-motion";
import ParticlesBackground from "../particles/ParticlesBackground";
import { useDispatch, useSelector } from "react-redux";
import { SET_PROJECT, SET_SCROLL } from "../../redux/types/types";
import { SocialMediaIconsReact } from "../../libraries/social-media-icons-react";
import { Link, useLocation } from "react-router-dom";
import { projectState } from "../../redux/action/action";
import myprojects from "../data/myprojects.project_details.json";
import myworks from "../data/myprojects.work_exp.json";
import Work from "../insidecomponents/Work";

function Home() {
  const [works, setworks] = useState([]);
  const [workExps, setworkExps] = useState([]);
  const [navToggle, setnavToggle] = useState(false);
  const [screenWidth, setscreenWidth] = useState(window.innerWidth);
  // const [scrollPage, setscrollPage] = useState(0);

  const scrollstate = useSelector((state) => state.scrollstate);
  const url_location = useLocation();
  const dispatch = useDispatch();

  //animate scroll locations of elements
  const [reloader, setreloader] = useState(false);

  const divRef = useRef();

  const topRef = useRef();
  const [topRefLoc, settopRefLoc] = useState(0);

  const aboutLabelRef = useRef();
  const [animateabout, setanimateabout] = useState(false);
  const [aboutRefLoc, setaboutRefLoc] = useState(0);

  const aboutDivRef = useRef();
  const [animateAboutDiv, setanimateAboutDiv] = useState(false);

  const worksDivRef = useRef();
  const [animateWorksDiv, setanimateWorksDiv] = useState(false);
  const [worksRefLoc, setworksRefLoc] = useState(0);

  const contactsDivRef = useRef();
  const [animateContactsDiv, setanimateContactsDiv] = useState(false);
  const [transitionInitiatorContacts, settransitionInitiatorContacts] =
    useState(false);
  const [contactsRefLoc, setcontactsRefLoc] = useState(0);

  useEffect(() => {
    // settopRefLoc(topRef.current.getBoundingClientRect().top)
    // setaboutRefLoc(aboutLabelRef.current.getBoundingClientRect().top)
    // setworksRefLoc(worksDivRef.current.getBoundingClientRect().top)
    // setcontactsRefLoc(contactsDivRef.current.getBoundingClientRect().top)
    // console.log({
    //   home: topRefLoc,
    //   about: aboutRefLoc,
    //   works: worksRefLoc,
    //   contacts: contactsRefLoc
    // })
  }, []);

  useEffect(() => {
    Aos.init({ duration: 2000, startEvent: "load" });
    Aos.refresh();
    dispatch({ type: SET_PROJECT, initialproject: projectState });
    dispatch({ type: SET_SCROLL, scrollstate: false });
  }, []);

  useEffect(() => {
    initProjects();
    initWorkExp();
  }, []);

  const initProjects = () => {
    // console.log(myworks);
    const reversedprojects = [...myprojects].reverse();
    setworks(reversedprojects);
    // Axios.get(`${URL_ONE}/works`)
    //   .then((response) => {
    //     // console.log(response.data)
    //     setworks(response.data.reverse());
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  const initWorkExp = () => {
    // console.log(myprojects);
    const reversedworks = [...myworks].reverse();
    setworkExps(reversedworks);
    // Axios.get(`${URL_ONE}/workExp`)
    //   .then((response) => {
    //     // console.log(response.data)
    //     setworkExps(response.data.reverse());
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //   });
  };

  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        setanimateabout(entry.isIntersecting);
      }
    });
    observer.observe(aboutLabelRef.current);

    const observerAboutDiv = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        setanimateAboutDiv(true);
      }
    });
    observerAboutDiv.observe(aboutDivRef.current);

    const observerWorksDiv = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        setanimateWorksDiv(entry.isIntersecting);
      }
    });
    observerWorksDiv.observe(worksDivRef.current);

    const observerContactsDiv = new IntersectionObserver((entries) => {
      const entry = entries[0];
      if (entry.isIntersecting) {
        setanimateContactsDiv(entry.isIntersecting);
        setTimeout(() => {
          settransitionInitiatorContacts(true);
        }, 2500);
      }
    });
    observerContactsDiv.observe(contactsDivRef.current);
  }, []);

  useEffect(() => {
    window.addEventListener("resize", () => {
      setscreenWidth(window.innerWidth);
    });

    const page = document.getElementById("div_home");

    page.addEventListener("scroll", (event) => {
      // console.log(page.scrollTop)
      // setscrollPage(page.scrollTop);

      // const aboutLabel = document.getElementById("about_label_p").offsetTop - document.getElementById("about_label_p").scrollTop;
      // console.log(page.scrollTop+" | "+worksDivPosition);

      if (page.scrollTop > 50) {
        dispatch({ type: SET_SCROLL, scrollstate: true });
      } else {
        dispatch({ type: SET_SCROLL, scrollstate: false });
      }
    });

    // console.log(window.scrollY)
  }, []);

  useEffect(() => {
    if (url_location.hash.includes("#works")) {
      worksDivRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [url_location]);

  return (
    <div id="div_home" ref={divRef}>
      <div id="div_preview" ref={topRef}>
        <motion.nav
          style={{
            backgroundColor: scrollstate
              ? "#353535"
              : navToggle
              ? "#353535"
              : "#353535", // transparent
          }}
          id="preview_nav"
        >
          <li
            className="li_preview_nav"
            id="li_hidder_uno"
            onClick={() => {
              setnavToggle(!navToggle);
            }}
          >
            <p id="logo_label">John Paulo</p>
          </li>
          <motion.li
            animate={{
              display:
                screenWidth < "720" ? (navToggle ? "block" : "none") : "block",
            }}
            className="li_preview_nav"
          >
            <button
              className="main_links"
              onClick={() => {
                topRef.current.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Home
            </button>
          </motion.li>
          <motion.li
            animate={{
              display:
                screenWidth < "720" ? (navToggle ? "block" : "none") : "block",
            }}
            className="li_preview_nav"
          >
            <button
              className="main_links"
              onClick={() => {
                aboutLabelRef.current.scrollIntoView({ behavior: "smooth" });
              }}
            >
              About
            </button>
          </motion.li>
          <motion.li className="li_preview_nav" id="li_hidder_dos">
            <p id="logo_label">John Paulo</p>
          </motion.li>
          <motion.li
            animate={{
              display:
                screenWidth < "720" ? (navToggle ? "block" : "none") : "block",
            }}
            className="li_preview_nav"
          >
            <button
              className="main_links"
              onClick={() => {
                worksDivRef.current.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Works
            </button>
          </motion.li>
          <motion.li
            animate={{
              display:
                screenWidth < "720" ? (navToggle ? "block" : "none") : "block",
            }}
            className="li_preview_nav"
          >
            <button
              className="main_links"
              onClick={() => {
                contactsDivRef.current.scrollIntoView({ behavior: "smooth" });
              }}
            >
              Contacts
            </button>
          </motion.li>
        </motion.nav>
        <nav id="initial_preview">
          <li className="li_initial_preview">
            <nav id="nav_labels_initial">
              <li className="li_labels_initial">
                <img src={Image} id="image_sizing" />
              </li>
              <li className="li_labels_initial">
                <p id="main_label_initial">Hi, I am John Paulo</p>
                <p id="role_label_initial">Software Engineer</p>
              </li>
            </nav>
          </li>
        </nav>
      </div>
      <hr className="line_divider" />
      <motion.p
        animate={{
          opacity: animateabout ? 1 : 0,
        }}
        transition={{
          duration: 1,
          delay: 0.2,
        }}
        className="section_labels"
        ref={aboutLabelRef}
        id="about_label_p"
      >
        About
      </motion.p>
      <motion.div
        animate={{
          opacity: animateAboutDiv ? 1 : 0,
        }}
        transition={{
          duration: 1,
          delay: 0.2,
        }}
        ref={aboutDivRef}
        id="div_about"
      >
        <nav id="about_nav">
          <li className="li_about uno_about"></li>
          <li className="li_about">
            {/* <p className='section_labels'>About</p> */}
            <span className="span_label">
              <Person style={{ fontSize: "40px" }} />
              <p className="tags_label_about">Who am I?</p>
            </span>
            <p id="about_main">
              My name is John Paulo Ramil Guimalan and I am a Software Engineer.
              Specializing in scalable web applications, microservices, and
              AI-driven systems. Proficient in FastAPI, React, TypeScript,
              Python, Docker, Kubernetes, and cloud deployments. Experienced in
              both backend and frontend development, ensuring seamless scaling
              with MongoDB, PostgreSQL, and Redis.
            </p>
            <span className="span_label">
              <Skills style={{ fontSize: "40px" }} />
              <p className="tags_label_about">Skills</p>
            </span>
            <nav id="nav_skills">
              <li>
                <p className="list_skills">
                  <img src={JavaScriptIcon} className="icon_skills" />
                  Vanilla JavaScript
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={ReactIcon} className="icon_skills" />
                  React JS
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={ReactIcon} className="icon_skills" />
                  React Native
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={PHPIcon} className="icon_skills" />
                  Core PHP
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={JQueryIcon} className="icon_skills" />
                  JQuery
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={HTMLIcon} className="icon_skills" />
                  HTML5
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={CSSIcon} className="icon_skills" />
                  CSS3
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={CSharpIcon} className="icon_skills" />
                  C# / .NET Framework
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={MongoDBIcon} className="icon_skills" />
                  MongoDB
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={MysqlIcon} className="icon_skills" />
                  MySQL
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={RestIcon} className="icon_skills" />
                  Rest API
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={ReduxIcon} className="icon_skills" />
                  Redux
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={NodeJSIcon} className="icon_skills" />
                  Node JS
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={ASPIcon} className="icon_skills" />
                  ASP.Net
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={MssqlIcon} className="icon_skills" />
                  Microsoft SQL
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={SQLiteIcon} className="icon_skills" />
                  SQLite
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={ExpressJSIcon} className="icon_skills" />
                  Express JS
                </p>
              </li>
              <li>
                <p className="list_skills">
                  <img src={CodeIgniterIcon} className="icon_skills" />
                  CodeIgniter
                </p>
              </li>
            </nav>
          </li>
        </nav>
      </motion.div>
      <motion.p
        animate={{
          opacity: animateabout ? 1 : 0,
        }}
        transition={{
          duration: 1,
          delay: 0.2,
        }}
        className="section_labels"
        id="about_label_p"
      >
        Work Experience
      </motion.p>
      <motion.div
        animate={{
          opacity: animateAboutDiv ? 1 : 0,
        }}
        transition={{
          duration: 1,
          delay: 0.2,
        }}
        id="div_workexp"
      >
        <nav id="nav_works">
          {workExps.length == 0 ? (
            <li id="li_loader_container">
              <div id="div_loader_container">
                <motion.div
                  animate={{
                    rotate: 360,
                  }}
                  transition={{
                    duration: 1,
                    repeat: Infinity,
                  }}
                  id="div_loader_icon"
                >
                  <LoadingRec style={{ fontSize: "40px" }} />
                </motion.div>
              </div>
            </li>
          ) : (
            workExps.map((data, i) => {
              return <Work key={i} data={data} />;
            })
          )}
        </nav>
      </motion.div>
      <hr className="line_divider_default" />
      <motion.div
        animate={{
          opacity: animateWorksDiv ? 1 : 0,
        }}
        transition={{
          duration: 0.5,
          delay: 0.2,
        }}
        ref={worksDivRef}
        id="div_works"
      >
        <p className="section_labels">Works</p>
        <nav id="nav_works">
          {works.length == 0 ? (
            <li id="li_loader_container">
              <div id="div_loader_container">
                <motion.div
                  animate={{
                    rotate: 360,
                  }}
                  transition={{
                    duration: 1,
                    repeat: Infinity,
                  }}
                  id="div_loader_icon"
                >
                  <LoadingRec style={{ fontSize: "40px" }} />
                </motion.div>
              </div>
            </li>
          ) : (
            works.map((details, i) => {
              return (
                <motion.li
                  animate={{
                    opacity: animateWorksDiv ? 1 : 0,
                  }}
                  transition={{
                    duration: 1,
                    delay: url_location.hash.includes("#works")
                      ? 0
                      : 0.5 + i / 2,
                  }}
                  key={details.projectID}
                  className="li_works"
                >
                  <Link
                    to={`/works/${details.projectID}`}
                    className="works_links"
                  >
                    <nav className="nav_list_works">
                      <li
                        className="preview_works"
                        style={{
                          background: `url("${details.image}")`,
                          backgroundRepeat: "no-repeat",
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          backgroundColor: "black",
                        }}
                      >
                        {/* <p className='title_works'>{details.title}</p> */}
                      </li>
                      <li>
                        <p className="title_works">{details.title}</p>
                      </li>
                    </nav>
                  </Link>
                </motion.li>
              );
            })
          )}
        </nav>
      </motion.div>
      <hr className="line_divider_default" />
      <motion.div
        animate={{
          opacity: animateContactsDiv ? 1 : 0,
        }}
        transition={{
          duration: 1,
          delay: 0.2,
        }}
        ref={contactsDivRef}
        id="div_contacts"
      >
        <p className="section_labels contacts_label">Contacts</p>
        <nav id="nav_btns_contacts">
          <li>
            <motion.div
              animate={{
                scale: animateContactsDiv ? 1 : 0,
                transition: {
                  duration: transitionInitiatorContacts ? 0.5 : 1,
                  delay: transitionInitiatorContacts ? 0 : 1.6,
                },
              }}
              whileHover={{
                rotate: 720,
                scale: 1.4,
                transition: {
                  duration: 1,
                },
              }}
              className="div_logo_contacts"
            >
              <SocialMediaIconsReact
                borderColor="rgba(0,0,0,0.25)"
                borderWidth="0"
                borderStyle="solid"
                icon="facebook"
                iconColor="rgba(255,255,255,1)"
                backgroundColor="rgba(59,89,152,1)"
                iconSize="1"
                roundness="100%"
                url="https://www.facebook.com/paulo.portesguimalan/"
                size="100%"
              />
            </motion.div>
          </li>
          <li>
            <motion.div
              animate={{
                scale: animateContactsDiv ? 1 : 0,
                transition: {
                  duration: transitionInitiatorContacts ? 0.5 : 1,
                  delay: transitionInitiatorContacts ? 0 : 1.8,
                },
              }}
              whileHover={{
                rotate: 720,
                scale: 1.4,
                transition: {
                  duration: 1,
                },
              }}
              className="div_logo_contacts instagram_icon"
            >
              <SocialMediaIconsReact
                borderColor="rgba(0,0,0,0.25)"
                borderWidth="0"
                borderStyle="solid"
                icon="instagram"
                iconColor="rgba(255,255,255,1)"
                backgroundColor="transparent"
                iconSize="1"
                roundness="100%"
                url="https://www.instagram.com/paologuimalan/"
                size="100%"
              />
            </motion.div>
          </li>
          <li>
            <motion.div
              animate={{
                scale: animateContactsDiv ? 1 : 0,
                transition: {
                  duration: transitionInitiatorContacts ? 0.5 : 1,
                  delay: transitionInitiatorContacts ? 0 : 2,
                },
              }}
              whileHover={{
                rotate: 720,
                scale: 1.4,
                transition: {
                  duration: 1,
                },
              }}
              className="div_logo_contacts"
            >
              <SocialMediaIconsReact
                borderColor="rgba(0,0,0,0.25)"
                borderWidth="0"
                borderStyle="solid"
                icon="github"
                iconColor="rgba(255,255,255,1)"
                backgroundColor="black"
                iconSize="1"
                roundness="100%"
                url="https://github.com/PaoloGuimalan"
                size="100%"
              />
            </motion.div>
          </li>
          <li>
            <motion.div
              animate={{
                scale: animateContactsDiv ? 1 : 0,
                transition: {
                  duration: transitionInitiatorContacts ? 0.5 : 1,
                  delay: transitionInitiatorContacts ? 0 : 2.2,
                },
              }}
              whileHover={{
                rotate: 720,
                scale: 1.4,
                transition: {
                  duration: 1,
                },
              }}
              className="div_logo_contacts"
            >
              <SocialMediaIconsReact
                borderColor="rgba(0,0,0,0.25)"
                borderWidth="0"
                borderStyle="solid"
                icon="mail"
                iconColor="orange"
                backgroundColor="white"
                iconSize="1"
                roundness="100%"
                url="mailto: pauloportes.guimalan187@gmail.com"
                size="100%"
              />
            </motion.div>
          </li>
          <li>
            <motion.div
              animate={{
                scale: animateContactsDiv ? 1 : 0,
                transition: {
                  duration: transitionInitiatorContacts ? 0.5 : 1,
                  delay: transitionInitiatorContacts ? 0 : 2.4,
                },
              }}
              whileHover={{
                rotate: 720,
                scale: 1.4,
                transition: {
                  duration: 1,
                },
              }}
              className="div_logo_contacts"
            >
              <SocialMediaIconsReact
                borderColor="rgba(0,0,0,0.25)"
                borderWidth="0"
                borderStyle="solid"
                icon="linkedin"
                iconColor="rgba(255,255,255,1)"
                backgroundColor="#0077B5"
                iconSize="1"
                roundness="100%"
                url="https://www.linkedin.com/in/john-paulo-ramil-guimalan-89029321a/"
                size="100%"
              />
            </motion.div>
          </li>
        </nav>
        {/* <nav id='nav_contacts_uno'>
          <li className='li_contacts_uno'>
            <nav id='nav_message_inputs'>
                <li>
                  <p id='message_label'>Message Me</p>
                </li>
                <li>
                  <input type='text' placeholder='Place here your Email.' id='email_holder' />
                </li>
                <li>
                  <textarea placeholder='Type your message.....' id='textarea_message'></textarea>
                </li>
                <li>
                  <button id='send_message_button'>Send</button>
                </li>
            </nav>
          </li>
          <li className='li_contacts_uno'>
            Hello
          </li>
        </nav> */}
      </motion.div>
    </div>
  );
}

export default Home;
